__turbopack_context__.v({
  "actions": "header-module__9iNmeq__actions",
  "appbar": "header-module__9iNmeq__appbar",
  "authCtas": "header-module__9iNmeq__authCtas",
  "brand": "header-module__9iNmeq__brand",
  "condensed": "header-module__9iNmeq__condensed",
  "desktopOnly": "header-module__9iNmeq__desktopOnly",
  "inner": "header-module__9iNmeq__inner",
  "nav": "header-module__9iNmeq__nav",
  "wordmark": "header-module__9iNmeq__wordmark",
});
